// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-pad {
    padding-left: 20px;
    padding-right: 20px;
}
.lr-heading {
    margin-bottom: 26px;
}
.lr-intro {
    margin-bottom: 27px;
}
.lr-list-header {
    line-height: 21px;
    size: 16px;
    font-family: 'Mecherle Sans SemiBold';
}
.lr-list {
    padding-left: 0;
    margin-bottom: 34px;
}
.lr-list li {
    list-style: none;
    display: flex;
    margin-bottom: 8px;
}
.lr-list li img{
    padding-right: 10px;
}
.checkmark{
  background-image: url('icon-checkmark.svg');
  width: 24px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  display: -webkit-inline-box;
  }
.lr-btn {
    margin-bottom: 32px;
}
.lr-back-link {
    display: block;
    text-align: center;
    margin-bottom: 55px;
}
@media only screen and (max-width: 600px) {
    .lr-gettingstarted-button {
        width: 200px;
        height: 48px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }
    .lr-back-container {
        width: 100%;
    }
    .lr-page-note {
        width: 240px;
        margin-left: auto;
        margin-right: auto;
    }
}
@media only screen and (min-width: 768px) {
    .lr-gettingstarted-button {
        width: 200px;
        height: 48px;
    }
    .lr-back-container {
        width: 200px;
    }
    .lr-page-note {
        width: 100%;
    }
}
@media only screen and (min-width: 992px) {
    .lr-gettingstarted-button {
        width: 240px;
        height: 56px;
    }
    .lr-back-container {
        width: 240px;
    }
}
@media(min-width: 768px) {
    .lr-pad {
        padding-left: 0;
        padding-right: 0;
    }
    .lr-heading {
        margin-bottom: 19px;
    }
    .lr-intro {
        margin-bottom: 29px;
    }
    .lr-list {
        margin-bottom: 56px;
    }
}
@media(min-width: 1200px) {
    .lr-heading {
        margin-bottom: 23px;
    }
    .lr-intro {
        font-weight: normal;
        font-size: 25px;
        line-height: 38px;
        color: #000;
        margin-bottom: 32px;
    }
    .lr-list {
        margin-bottom: 34px;
    }
}
.lr-nowrap {
    white-space: nowrap;
}

/* 
a.th-load-more.-oneX-load-more {
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  width: 200px;
}


#myMapId {
  height: 400px;
  width: 100%;
}
#myMapId {
  height: 400px;
  width: 100%;
}

#myTest-content .title {
  font-weight: bold;
}

#myTest-content {
  display: none;
}

#myMapId #myTest-content {
  display: inline;
}
.-oneX-progress-bar.-oneX-progress--single .-oneX-progress-tracker .-oneX-progress-marker {
    background-color: #e22925;
    height: 5px;
    margin-top: -1px;
} */
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/claimant/claimant-landing/claimant-landing.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,qCAAqC;AACzC;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;EACE,2CAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B;AACF;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG","sourcesContent":[".lr-pad {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n.lr-heading {\n    margin-bottom: 26px;\n}\n.lr-intro {\n    margin-bottom: 27px;\n}\n.lr-list-header {\n    line-height: 21px;\n    size: 16px;\n    font-family: 'Mecherle Sans SemiBold';\n}\n.lr-list {\n    padding-left: 0;\n    margin-bottom: 34px;\n}\n.lr-list li {\n    list-style: none;\n    display: flex;\n    margin-bottom: 8px;\n}\n.lr-list li img{\n    padding-right: 10px;\n}\n.checkmark{\n  background-image: url(../../../assets/img/icon-checkmark.svg);\n  width: 24px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: -webkit-inline-box;\n  }\n.lr-btn {\n    margin-bottom: 32px;\n}\n.lr-back-link {\n    display: block;\n    text-align: center;\n    margin-bottom: 55px;\n}\n@media only screen and (max-width: 600px) {\n    .lr-gettingstarted-button {\n        width: 200px;\n        height: 48px;\n        margin-left: auto;\n        margin-right: auto;\n        display: block;\n    }\n    .lr-back-container {\n        width: 100%;\n    }\n    .lr-page-note {\n        width: 240px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n@media only screen and (min-width: 768px) {\n    .lr-gettingstarted-button {\n        width: 200px;\n        height: 48px;\n    }\n    .lr-back-container {\n        width: 200px;\n    }\n    .lr-page-note {\n        width: 100%;\n    }\n}\n@media only screen and (min-width: 992px) {\n    .lr-gettingstarted-button {\n        width: 240px;\n        height: 56px;\n    }\n    .lr-back-container {\n        width: 240px;\n    }\n}\n@media(min-width: 768px) {\n    .lr-pad {\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .lr-heading {\n        margin-bottom: 19px;\n    }\n    .lr-intro {\n        margin-bottom: 29px;\n    }\n    .lr-list {\n        margin-bottom: 56px;\n    }\n}\n@media(min-width: 1200px) {\n    .lr-heading {\n        margin-bottom: 23px;\n    }\n    .lr-intro {\n        font-weight: normal;\n        font-size: 25px;\n        line-height: 38px;\n        color: #000;\n        margin-bottom: 32px;\n    }\n    .lr-list {\n        margin-bottom: 34px;\n    }\n}\n.lr-nowrap {\n    white-space: nowrap;\n}\n\n/* \na.th-load-more.-oneX-load-more {\n  display: flex;\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n  width: 200px;\n}\n\n\n#myMapId {\n  height: 400px;\n  width: 100%;\n}\n#myMapId {\n  height: 400px;\n  width: 100%;\n}\n\n#myTest-content .title {\n  font-weight: bold;\n}\n\n#myTest-content {\n  display: none;\n}\n\n#myMapId #myTest-content {\n  display: inline;\n}\n.-oneX-progress-bar.-oneX-progress--single .-oneX-progress-tracker .-oneX-progress-marker {\n    background-color: #e22925;\n    height: 5px;\n    margin-top: -1px;\n} */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
